import React, { Component } from 'react';
import { connect } from 'react-redux';
import { hashHistory } from 'react-router';
import NavigatorMain from './NavigatorMain';
import { getCapchaCode, ReservationManager,getCapcha,getMobileCaptcha } from '../action/loginAction.js';
import {getVerifyCode} from '../action/investmentAction.js';
import { Toast,Modal } from 'antd-mobile/lib';
import  { AlerModleLcs } from './fundDetail/AlerModle';
import Util from '../util';


function closest(el, selector) {
  const matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;
  while (el) {
    if (matchesSelector.call(el, selector)) {
      return el;
    }
    el = el.parentElement;
  }
  return null;
}

  

class ReservationsManager extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name:'',
      mobileNum:'',
      VerificationCode:'',
      serverCapchaCode: '',
      imageBase64: '',
      phoneCode:'',
      txt:"获取验证码",
      num:30,
      isRequestingVerifyCode: false,
      imgCode:true,
      sex:'1',
      modal1: false,
    };
    this.PopDid = false;
    this.requestId = '';
    this.intervalId = null;
  }
  componentDidMount(){
    // this.props.dispatch(getCapchaCode({scale: 2},(code, imageBase64)=>{console.log('1&&&&&&&&&&'); this.getCapchaCodeSuccess(code,imageBase64)}, (msg)=>{this.getCapchaCodeError(msg)}));
    this.props.dispatch(getCapcha((code, imageBase64)=>{console.log('1&&&&&&&&&&'); this.getCapchaCodeSuccess(code,imageBase64)}, (msg)=>{this.getCapchaCodeError(msg)}));
  }
  componentWillMount(){
     window._czc.push(["_trackEvent", "华夏财富H5", "理财师", "进入理财师"]);
     document.title = "预约理财师"
    let {dispatch}=this.props;
  }
  componentWillUnmount(){
    window._czc.push(["_trackEvent", "华夏财富H5", "理财师", "离开理财师"]);
  }
  succallback(){
    // alert()
  }
  errcallback(msg){
    // alert(msg)
  }

  getCapchaCodeSuccess(code, imageBase64){
    console.log('verifySuccess');
    this.setState({
      serverCapchaCode: code,
      imageBase64,
      getCapchaSuccess:true
    });
  }
  getCapchaCodeAgain(){
    this.setState({
      VerificationCode:''
    })
    this.props.dispatch(getCapcha((code,imageBase64)=>{this.getCapchaCodeSuccess(code,imageBase64)}, (msg)=>{this.getCapchaCodeError(msg)}));
  }
  getCapchaCodeError(msg){
    Toast.info(msg, Util.ToastTime );
    this.setState({getCapchaSuccess: false});
  }
  getVerificationCode(){
    let { mobileNum,serverCapchaCode,VerificationCode } = this.state;
    let params = {
      mobileNo: mobileNum,
      token: serverCapchaCode,
      captchaCode: VerificationCode.toUpperCase()
    };
    if(!(/^1[0123456789]\d{9}$/.test(this.state.mobileNum))){
      Toast.info('请输入正确的手机号码', Util.ToastTime);
      return ;
    }

    if(this.state.VerificationCode){
      this.props.dispatch(getMobileCaptcha(params,(requestId)=>{this.getMobileCaptchaSucc(requestId)},(succ)=>{this.getMobileCaptchaErr(succ)}));
    }else{
      Toast.info('请输入图形验证码', Util.ToastTime);
    }

    // this.props.dispatch(getVerifyCode(mobileNum, (requestId)=>{this.requestId = requestId; console.log(requestId)}));
   
  }
  getMobileCaptchaSucc(requestId){
    this.requestId = requestId; 
    console.log(requestId)
      let countNum = 119;
    this.setState({isRequestingVerifyCode: true, num: countNum}, ()=>{
      this.intervalId = setInterval(() => {
        countNum--;
        if(countNum < 0){
          this.getCapchaCodeAgain();
          cancelTimeOut();
          this.setState({
            isRequestingVerifyCode: false
          });
        }
        this.setState({
          num: countNum
        })
      }, 1000);
      const cancelTimeOut = () => {
        if(this.intervalId)
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    });
  }
  getMobileCaptchaErr(succ){
    Toast.show(succ.message, Util.ToastTime);
    this.getCapchaCodeAgain();
  }
  handleVerify(){
    if(!(/^1[0123456789]\d{9}$/.test(this.state.mobileNum))){
      Toast.info('请输入正确的手机号码', Util.ToastTime);
      return ;
    }

    let imgCodeFlag = true;
    if(!this.state.VerificationCode){
      Toast.info('请输入图形验证码', Util.ToastTime);
      imgCodeFlag = false;
    }
    if(!imgCodeFlag){
      return false
    }

    if(this.requestId === '' || !this.requestId){
      Toast.info('请先申请手机验证码', Util.ToastTime);
      return ;
    }
    if(this.state.name === ""){
      Toast.info('请输入姓名', Util.ToastTime);
      return ;
    }

    let verifyParam = {
      requestId : this.requestId,
      userName:this.state.name,
      mobileNo : this.state.mobileNum,
      captchaCode: this.state.phoneCode,
      sex:this.state.sex
    }
    console.log(verifyParam);
    this.setState({
      loading: true
    })
    this.props.dispatch(ReservationManager(verifyParam, (d)=>{this.verifySuccess(d)}, (msg)=>this.verifyError(msg)));
  }
  verifySuccess(data){
     window._czc.push(["_trackEvent", "华夏财富H5", "理财师", "立即预约btn"]);
     document.getElementsByTagName('html')[0].style.overflowY='hidden';
     document.getElementsByTagName('body')[0].setAttribute('ontouchmove',"event.preventDefault()")
    console.log(data)
    if(data === true){
       if(this.intervalId){clearInterval(this.intervalId); }
      this.setState({
        modal1:true,
        name:"",
        mobileNum : "",
        phoneCode: "",
        VerificationCode:"",
        isRequestingVerifyCode:false
      })
    }
  }
  verifyError(msg){

  }
  showModal = key => (e) => {
    e.preventDefault(); // 修复 Android 上点击穿透
    this.setState({
      [key]: true,
    });
  }
  onClose = key => () => {
    this.setState({
      [key]: false,
    });
  }

  onWrapTouchStart = (e) => {
    // fix touch to scroll background page on iOS
    if (!/iPhone|iPod|iPad/i.test(navigator.userAgent)) {
      return;
    }
    const pNode = closest(e.target, '.am-modal-content');
    if (!pNode) {
      e.preventDefault();
    }
  }
  render(){
    let width = window.screen.width;
    let height = window.screen.height;
    let { imgCode, mobileNum, name, VerificationCode } = this.state;
    return (
        <div className="mainBg_manager" >
          <div className="header_bg" style={{width:"100%",height:width*(2080/1125)}}>
            <div style={{ height:width*(2080/1125) * (600/2080) }}>
              
            </div>
            <div className="conBotton">
              <div className="inputContent" style={{ paddingLeft:width * (65/1125), paddingRight:width * (65/1125) }}>
                <div style={{paddingLeft:13, paddingRight:13,background:"#FFF", height:"auto",borderRadius:10,paddingBottom:20 }}>
                  <div className="inputName">
                    <div className="labal"><span>姓</span><span>名</span></div>
                    <div className="lineCut" style={{marginLeft:12}}></div>
                 
                    <div className="inputWrap">
                      <input className="textInput"  placeholder="请输入您的姓名" value={ name } onChange={ (e) =>{ this.setState({ name: e.target.value})  } } />
                    </div>
                  </div>

                  <div className="inputName">
                    <div className="labal"><span>手</span><span>机</span><span>号</span></div>
                    <div className="lineCut" style={{marginLeft:12}}></div>
               
                    <div className="inputWrap">
                      <input className="textInput"  placeholder="请输入您的手机号" value={ mobileNum } onChange={ (e) =>{ this.setState({ mobileNum: e.target.value})  } } />
                    </div>
                  </div>

                  <div className="inputName">
                    <div className="labalTwo">图形验证码</div>
                    <div className="lineCut" ></div>
                    <div className="inputWrap">
                      <input className="textInput"  placeholder="请输入图形验证码" value={ this.state.VerificationCode } onChange={ (e) =>{ this.setState({ VerificationCode: e.target.value})  } } />
                    </div>
                    <div onClick = {()=>{this.getCapchaCodeAgain()}}>
                      <img style={{
                        width: 63,
                        height: 27
                      }} src={`data:image/png;base64,${this.state.imageBase64}`} />
                    </div>
                  </div>

                  <div className="inputName">
                    <div className="labalTwo">短信验证码</div>
                    <div className="lineCut"></div>
                    <div className="inputWrap">
                      <input className="textInput"  placeholder="请输入短信验证码" value={ this.state.phoneCode } onChange={ (e) =>{ this.setState({ phoneCode: e.target.value})  } } />
                    </div>
                    {
                       !this.state.isRequestingVerifyCode ? 
                        <div onClick={()=>this.getVerificationCode() } className="getCodeBg">
                            <span style={{color:"#FFF",fontSize:12,backgroundColor:"rgba(0,0,0,0)"}}>{this.state.txt}</span>
                        </div> : 
                        <div className="getCodeBg">
                            <span style={{color:"#FFF",fontSize:12,backgroundColor:"rgba(0,0,0,0)"}}>{this.state.num + "S"}</span>
                        </div>
                    }
                  </div>
                  <div onClick={()=>this.handleVerify()} style={{
                    borderRadius: 20,
                    backgroundColor: "#fa063a",
                    height: 42,
                    borderRadius: 20,
                    WebkitFlexDirection: 'row',
                    WebkitAlignItems: 'center',
                    WebkitJustifyContent: 'center',
                    display: "-webkit-flex",
                    marginTop: 15
                  }}>
                    <span style={{color: '#ffffff', fontSize: 17}}>立即预约</span>
                  </div>
                </div>
              </div>

            </div>
          </div>
          
          {/*
          <div style={{padding:13, paddingRight:13,paddingTop:15, paddingBottom:5 }}>

            <div className="briefOne" style={{width:width-26, height:(width-26)*(370/690)}}>
              
            </div>

            <div className="lcs_xj_wrap">
              <div className="lcs_xj" style={{width:16, height:52}}></div>
              <div className="lcs_xj" style={{width:16, height:52}}></div>
            </div>
            <div className="show_content_manager" >
              <div className="show_list_manager">
                <div className="letImgWrap">
                  <div className="letImg hxjjImg" >
                    
                  </div>
                </div>
                <div className="name_wrap">
                  <div style={{fontSize:"0.23rem", color:"#282828",lineHeight:"0.26rem", marginTop:5,paddingRight:3}}>华夏基金建立了完善的产品线，旗下公募基金超过
                      150只。截止2019年6月30日，服务机构客户超过46000户，服务公众持有人超过1亿户，累计分红超过1536亿元。
                  </div>
                
                </div>
              </div>
            </div>


            <div className="briefTwo" style={{width:width-26, height:(width-26)*(316/690), marginTop:20 }}>
              
            </div>

            <div className="lcs_xj_wrap">
              <div className="lcs_xj" style={{width:16, height:52}}></div>
              <div className="lcs_xj" style={{width:16, height:52}}></div>
            </div>
            <div className="show_content_manager manListBg" >
                <div className="show_list_manager">
                  <div className="letImgWrap">
                    <div className="letImg wywImg" >
                      
                    </div>
                  </div>
                  <div className="name_wrap">
                    <div style={{fontSize:"0.26rem" }}>王亚伟</div>
                    <div style={{fontSize:"0.23rem", color:"#282828",lineHeight:"0.24rem", marginTop:5,paddingRight:3}}>曾被评为 "中国最赚钱的基金经理"。</div>
                  
                  </div>
                </div>

                <div className="show_list_manager">
                  <div className="letImgWrap">
                    <div className="letImg qdzImg" >
                      
                    </div>
                  </div>
                  <div className="name_wrap">
                    <div style={{fontSize:"0.26rem", color:"#1d529B" }}>邱国鹭</div>
                    <div style={{fontSize:"0.23rem", color:"#282828", marginTop:5,paddingRight:3}}>曾任南方基金投资总监和投委会主席，20年从业经历中包含了60亿美元资产管理公司合伙人、跨国对冲基金创始人、2800亿公募基金公司投研负责人等经验。 </div>
                  </div>
                </div>

                <div className="show_list_manager">
                  <div className="letImgWrap">
                    <div className="letImg jlImg" >
                      
                    </div>
                  </div>
                  <div className="name_wrap">
                    <div style={{fontSize:"0.26rem", color:"#1d529B" }}>蒋锦志</div>
                    <div style={{fontSize:"0.23rem", color:"#282828", marginTop:5,paddingRight:3}}>国内成立最早及管理规模最大的私募基金管理人之一。</div>
                  </div>
                </div>
                
                <div className="show_list_manager">
                  <div className="letImgWrap">
                    <div className="letImg DsImg" >
                      
                    </div>
                  </div>
                  <div className="name_wrap">
                    <div style={{fontSize:"0.26rem", color:"#1d529B" }}>Paul J. DeNoon</div>
                    <div style={{fontSize:"0.23rem", color:"#282828", marginTop:5,paddingRight:3}}>新兴市场债券总监。联博拥有杰出的基本面与定量分析研究团队，50多年来持续运用创新研究和严谨的投资流程，结合遍布全球的集团资源，为投资者提供多种固定收益投资策略和定制解决方案，经历市场长期考验，连续多年获全球各大资产管理与基金奖项肯定。</div>
                  </div>
                </div>
                
                <div className="show_list_manager">
                  <div className="letImgWrap">
                    <div className="letImg wlzsImg" >
                      
                    </div>
                  </div>
                  <div className="name_wrap">
                    <div style={{fontSize:"0.26rem", color:"#1d529B" }}>刘文动、巩怀志</div>
                    <div style={{fontSize:"0.23rem", color:"#282828", marginTop:5,paddingRight:3}}>公募和私募双料金牛基金奖。</div>
                  </div>
                </div>
                
                <div className="show_list_manager">
                  <div className="letImgWrap">
                    <div className="letImg hjpImg" >
                      
                    </div>
                  </div>      
                  <div className="name_wrap">
                    <div style={{fontSize:"0.26rem", color:"#1d529B" }}>胡建平</div>
                    <div style={{fontSize:"0.23rem", color:"#282828", marginTop:5,paddingRight:3}}>六座中国证券报金牛奖得主。</div>
                  </div>
                </div>

                <div className="show_list_manager">
                  <div className="letImgWrap">
                    <div className="letImg zwqImg" >
                      
                    </div>
                  </div>
                  <div className="name_wrap">
                    <div style={{fontSize:"0.26rem", color:"#1d529B" }}>周文群</div>
                    <div style={{fontSize:"0.23rem", color:"#282828", marginTop:5,paddingRight:3}}>全球最受信赖资产管理人富达(Fidelity)国际中国团队。</div>
                  </div>
                </div>

                <div className="show_list_manager">
                  <div className="letImgWrap">
                    <div className="letImg zahImg" >
                      
                    </div>
                  </div>
                  <div className="name_wrap">
                    <div style={{fontSize:"0.26rem", color:"#1d529B" }}>施斌</div>
                    <div style={{fontSize:"0.23rem", color:"#282828", marginTop:5,paddingRight:3}}>瑞银资产管理（上海）有限公司，拥有外商独资私募证券投资基金管理人牌照，以及QDLP（合格境内有限合伙人）牌照，专注证券投资私募基金业务，包括股票、债券、FOF以及多元资产配置。</div>
                  </div>
                </div>

                <div className="show_list_manager">
                  <div className="letImgWrap">
                    <div className="letImg xjImg" >
                      
                    </div>
                  </div>
                  <div className="name_wrap">
                    <div style={{fontSize:"0.26rem", color:"#1d529B" }}>梁辉</div>
                    <div style={{fontSize:"0.23rem", color:"#282828", marginTop:5,paddingRight:3}}>囊括6座公募、私募金牛基金奖。</div>
                  </div>
                </div>

                <div className="show_list_manager">
                  <div className="letImgWrap">
                    <div className="letImg wxImg" >
                      
                    </div>
                  </div>
                  <div className="name_wrap">
                    <div style={{fontSize:"0.26rem", color:"#1d529B" }}>吴星</div>
                    <div style={{fontSize:"0.23rem", color:"#282828", marginTop:5,paddingRight:3}}>专注于大宗商品、债券、权益类资产及其衍生品市场投资的全球宏观私募基金管理公司，2014年开始连续五年获得金牛奖。</div>
                  </div>
                </div>

                <div className="show_list_manager">
                  <div className="letImgWrap">
                    <div className="letImg mckImg" >
                      
                    </div>
                  </div> 
                  <div className="name_wrap">
                    <div style={{fontSize:"0.26rem", color:"#1d529B" }}>陈斌</div>
                    <div style={{fontSize:"0.23rem", color:"#282828", marginTop:5,paddingRight:3}}>历任全球顶尖商业智能软件公司微策略、大型期货公司金融工程部、资管部策略研究负责人，对量化策略研发管理和产品运作有丰富经验。</div>
                  </div>
                </div>


            </div>

            
            <div style={{ height:90,paddingRight:13,paddingLeft:13, paddingTop:10}}>
                <div style={{color:"#FFF",fontSize:"0.24rem",lineHeight:"16px"}}>
                  上海华夏财富投资管理有限公司，是华夏基金全资子公司，拥有中国证监会颁布的基金销售牌照，是中国基金业协会联席会员。
                </div>
                <div style={{fontSize:"0.22rem",marginTop:5,color:"#FFF"}}>市场有风险，投资需谨慎</div>
            </div>




          </div>

          */}


          {
            this.state.modal1 ? <AlerModleLcs content="预约成功，理财师将在三个工作日内与您联系，请保持电话畅通。"  CloseAler = { ()=> { this.setState({ modal1:false }) } }/> : null
          } 
        </div>
    );
  }
}


function mapStateToProps(state, ownProps) {
  return {

  }
}

export default connect(mapStateToProps)(ReservationsManager);



// WEBPACK FOOTER //
// ./src/components/ReservationsManager.js